class CaloriesInputFactory {
  constructor(
    calculatorReference,
    valueChangedCallback,
    inputFocusPageIndexCallback
  ) {
    this.calculator = calculatorReference;
    this.inputs = null;
    this.valueChangedCallback = valueChangedCallback;
    this.inputFocusPageIndexCallback = inputFocusPageIndexCallback;

    this.setterMap = {
      target: (value) => this.calculator.setTarget(value),
      training: (value) => this.calculator.setTraining(value),
      activity: (value) => this.calculator.setActivity(value),
      weight: (value) => this.calculator.setWeight(value),
      size: (value) => this.calculator.setSize(value),
      age: (value) => this.calculator.setAge(value),
      gender: (value) => this.calculator.setGender(value),
      sleep: (value) => this.calculator.setSleep(value)
    };
  }

  setInputs(inputs) {
    this.inputs = inputs;
  }

  init() {
    Object.values(this.inputs).forEach((inputObject) => {
      const inputElements = document.querySelectorAll(`[name="${inputObject.name}"]`);
      inputElements.forEach((inputElement) => {
        const eventType = this._getEventType(inputElement.type);
        inputElement.addEventListener(eventType, (e) => this._handleInputChange(e));
      });
    });
  }

  _getEventType(inputType) {
    return (inputType === "number" || inputType === "text") ? "keyup" : "change";
  }

  _handleInputChange(e) {
    const { target } = e;
    let inputValue = this._getInputValue(target);

    this._removeErrorClass(target);

    if (this._isInvalidInput(target, inputValue)) {
      this._addErrorClass(target);
      inputValue = null;
    }

    this._updateCalculator(target.dataset.target, inputValue);
    this.valueChangedCallback();
  }

  _getInputValue(target) {
    if (target.type === "text" || target.type === "number" || target.type === "select-one") {
      return target.value;
    }
    return target.dataset.factor;
  }

  _removeErrorClass(target) {
    if (target.type === "radio") {
      document.querySelectorAll(`input[name="${target.name}"]`)
        .forEach((element) => element.classList.remove("error"));
    } else {
      target.classList.remove("error");
    }
  }

  _addErrorClass(target) {
    if (target.type === "radio") {
      document.querySelectorAll(`input[name="${target.name}"]`)
        .forEach((element) => element.classList.add("error"));
    } else {
      target.classList.add("error");
    }
  }

  _isInvalidInput(target, inputValue) {
    if (inputValue === "") return true;
    if (target.type === "select-one" && inputValue == -1) return true;
    if (target.type === "number") {
      const value = parseFloat(inputValue);
      const min = parseFloat(target.min);
      const max = parseFloat(target.max);
      return value < min || value > max;
    }
    return false;
  }

  _updateCalculator(targetName, inputValue) {
    const setter = this.setterMap[targetName];
    if (setter) {
      setter(inputValue);
    }
  }
}
